// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "screen and (max-width: 600px)";
var _4 = "container-VYhpR";
var _5 = "label-3tGL_";
var _6 = "controls-37-Jf";
var _7 = "control-2DWrM";
export { _1 as "__esModule", _2 as "tablet", _3 as "mobile", _4 as "container", _5 as "label", _6 as "controls", _7 as "control" }
export default { "__esModule": _1, "tablet": _2, "mobile": _3, "container": _4, "label": _5, "controls": _6, "control": _7 }
